import React from "react";
import { Container, Col, Row } from "reactstrap";
import { Fields } from "@repoflow/components/fields";
import { useSectionContext } from "@repoflow/components/section";
import { Link } from "react-router-dom";
import * as widgets from "widgets/register";

export const Sidebar = () => null;

export const Indice = () => null;

// The page, and the two things you can do to it.
//
// A page owns nothing — no child collection, no derived figures — so this screen
// is the entity and its actions and stops there. That is deliberate rather than
// unfinished: the service this was derived from grew a statistics block and two
// nested listings on the equivalent screen, and both listings duplicated a
// section one click away.
export const Content = () => {
  const { values, schema, base } = useSectionContext();

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <div className="float-right">
            <Link className="btn btn-primary" to={`${base}/edit`}>
              Edit
            </Link>{" "}
            <Link className="btn btn-danger" to={`${base}/remove`}>
              Remove
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Fields
            schema={schema}
            values={values}
            widgets={widgets}
            target={{ $ref: "/Public/Page" }}
            config={{
              "/Public/Page": {
                fields: ["pageId", "title", "slug", "body"],
              },
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};
